import { render, staticRenderFns } from "./group-popover.vue?vue&type=template&id=504bd980&scoped=true&"
import script from "./group-popover.vue?vue&type=script&lang=js&"
export * from "./group-popover.vue?vue&type=script&lang=js&"
import style0 from "./group-popover.vue?vue&type=style&index=0&id=504bd980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504bd980",
  null
  
)

export default component.exports